/**
 * Created by yangrui on 2021/5/26.
 */
'use strict';
import request from "@/api/axios";

/** v2.3.8 start **/

//担保详情审核保单
export function getShxx(params) {
    return request({
        url: 'ssbq/api/ssdb/dbxx/bdjfshxx',
        method: 'get',
        params: {
            time: new Date().getTime(),
            dbid: params
        }
    })
}

//获取证据信息列表
export function getXcxZjList(params) {
    return request({
        url: 'ssbq/api/xwzj/zjxxs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}
//获取证据信息
export function getXcxZj(params) {
    return request({
        url: 'ssbq/api/xwzj/xcx/zjxx',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//新增或者编辑证据信息接口
export function addXcxZj(params,data) {
    return request({
        url: 'ssbq/api/xwzj/xcx/bczjxx',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}
//获取行为信息列表
export function getXcxXwList(params) {
    return request({
        url: 'ssbq/api/xwzj/xwxxs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//获取行为信息
export function getXcxXw(params) {
    return request({
        url: 'ssbq/api/xwzj/xcx/xwxx',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//新增或者编辑行为信息接口
export function addXcxXw(params,data) {
    return request({
        url: 'ssbq/api/xwzj/xcx/bcxwxx',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}
/**
 * 解除保全财产线索查询接口
 * @param params
 */
export function getJcCcxs(params) {
    return request({
        url: 'ssbq/api/ssbq/jc/ccxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}

/**
 * 解除保全证据信息查询接口
 * @param params
 */
export function getJcZjxx(params) {
    return request({
        url: 'ssbq/api/ssbq/jc/zjxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 解除保全行为信息查询接口
 * @param params
 */
export function getJcXwxx(params,data) {
    return request({
        url: 'ssbq/api/ssbq/jc/xwxx',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}
// 删除证据信息
export function delXcxZj(params) {
    return request({
        url: 'ssbq/api/xwzj/xcx/sczjxx',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}
//删除行为信息
export function delXcxXw(params) {
    return request({
        url: 'ssbq/api/xwzj/xcx/scxwxx',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}
/**
 * 续行保全财产线索查询接口
 * @param params
 */
export function getXxCcxs(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/ccxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}

/**
 * 续行保全证据信息查询接口
 * @param params
 */
export function getXxZjxx(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/zjxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}

/**
 * 续行保全行为信息查询接口
 * @param params
 */
export function getXxXwxx(params) {
    // alert('续行保全行为信息'+ JSON.stringify(params))
    return request({
        url: 'ssbq/api/ssbq/xx/xwxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}

/**
 * 续行保全担保信息查询接口
 * @param params
 */
export function getXxDbxx(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/dbxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 续行保全线上诉责险接口
 * @param params
 */
export function getXxSszrx(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/sszrx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}


/** v2.3.8 end **/


/** v2.3.7 start **/

//v2.3.7 9.法院代字
export function checkDZ(params) {
    return request({
        url: 'ssbq/api/dz',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//v2.3.7 3.申请变更担保-封装数据
export function getDbbgBbjbxx(params) {
    return request({
        url: 'commonapi/api/bgdb/dbjbxx/'+params,
        method: 'get',
        params: {
            time: new Date().getTime()
        }
    })
}

//原接口 1
export function getDbjbxx(params) {
    return request({
        url: 'ssbq/api/ssdb/dbjbxx',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//原接口 2
export function getSqrs(params) {
    return request({
        url: 'ssbq/api/ssdb/sqrs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}
//原接口 3
export function getBsqrs(params) {
    return request({
        url: 'ssbq/api/ssdb/bsqrs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//原接口 4
export function getYgdlrs(params) {
    return request({
        url: 'ssbq/api/ssdb/ygdlrs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//原接口 5
export function getCcxss(params) {
    return request({
        url: 'ssbq/api/ssdb/ccxss',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//原接口 6
export function getSccls(params) {
    return request({
        url: 'ssbq/api/ssdb/sccls',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//申请人 删除 原接口 正常状态
export function deleteSqr(params) {
    console.log('--deleteSqr 123',params);
    return request({
        url: 'ssbq/api/xcx/deletesqr',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//申请人 删除 新接口 变更状态
export function delXcxSqr(params) {
    console.log('--deleteSqr 123',params);
    return request({
        url: 'commonapi/api/bgdb/xcx/sqr',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//申请人 添加 原接口 正常状态
export function addDbSqr(params,data) {
    return request({
        url: 'ssbq/api/xcx/dbSqr',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//申请人 添加  新接口 变更状态
export function addSqr(params,data) {
    return request({
        url: 'commonapi/api/bgdb/xcx/sqr',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//申请人 查询 原接口 正常状态
export function getSqrbyIdOld(params) {
    return request({
        url: 'ssbq/api/ssdb/sqr',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//申请人 查询  新接口 变更状态
export function getSqrById(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/sqr',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}







//被申请人 删除 原接口 正常状态
export function deleteBsqr(params) {
    console.log('--deleteSqr 123',params);
    return request({
        url: 'ssbq/api/xcx/deletebsqr',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//被申请人 删除 新接口 变更状态
export function delXcxBsqr(params) {
    console.log('--deleteSqr 123',params);
    return request({
        url: 'commonapi/api/bgdb/xcx/bsqr',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//被申请人 添加 原接口 正常状态
export function addDbDsr(params,data) {
    return request({
        url: 'ssbq/api/xcx/dbDsr',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//被申请人 添加  新接口 变更状态
export function addBsqr(params,data) {
    return request({
        url: 'commonapi/api/bgdb/xcx/bsqr',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//被申请人 查询 原接口 正常状态
export function getBsqrbyIdOld(params) {
    return request({
        url: 'ssbq/api/ssdb/bsqr',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//被申请人 查询  新接口 变更状态
export function getBsqrById(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/bsqr',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}













//原告代理人 删除 原接口 正常状态
export function deleteDlr(params) {
    return request({
        url: 'ssbq/api/xcx/deletedlr',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//原告代理人 删除 新接口 变更状态
export function delXcxDlr(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/dlr',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//原告代理人 添加 原接口 正常状态
export function addDbDlr(params,data) {
    return request({
        url: 'ssbq/api/xcx/dbDlr',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//原告代理人 添加  新接口 变更状态
export function addXcxBsqr(params,data) {
    return request({
        url: 'commonapi/api/bgdb/xcx/dlr',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//原告代理人 查询 原接口 正常状态
export function getYgdlr(params) {
    return request({
        url: 'ssbq/api/ssdb/ygdlr',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//原告代理人 查询  新接口 变更状态
export function getXcxDlr(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/dlr',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//申请人列表 查询  新接口 变更状态
export function getXcxSqrs(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/sqrs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//被申请人列表 查询  新接口 变更状态
export function getXcxBsqrs(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/bsqrs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}











//财产线索 删除 原接口 正常状态
export function deleteCcxs(params) {
    return request({
        url: 'ssbq/api/xcx/deleteccxs',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//财产线索 删除 新接口 变更状态
export function delXcxCcxs(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/ccxs',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//财产线索 添加 原接口 正常状态
export function addDbCcxs(params,data) {
    return request({
        url: 'ssbq/api/xcx/dbCcxs',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//财产线索 添加  新接口 变更状态
export function addXcxCcxs(params,data) {
    return request({
        url: 'commonapi/api/bgdb/xcx/ccxs',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data:data
    })
}

//财产线索 查询 原接口 正常状态
export function getCcxs(params) {
    return request({
        url: 'ssbq/api/ssdb/ccxs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//财产线索 查询  新接口 变更状态
export function getXcxCcxs(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/ccxs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}










//上传材料 上传 原接口 正常状态
export function fileUpload(data,fn) { //路径等待确认
    return request({
        url: 'ssbq/api/ssdb/fileupload',
        method: 'post',
        headers: {
            "Content-Type": 'multipart/form-data',
        },
        params: {
            time: new Date().getTime(),
        },
        data:data,
        onUploadProgress:fn
    })
}

//v2.3.7 5.变更担保-材料上传
//上传材料 上传  新接口 变更状态
export function fileXcxUpload(data) {
    return request({
        url: 'commonapi/api/bgdb/fileupload',
        method: 'post',
        headers: {
            "Content-Type": 'multipart/form-data',
        },
        params: {
            time: new Date().getTime(),
        },
        data:data
    })
}

//上传材料 删除 原接口 正常状态
export function delSccl(params) {
    return request({
        url: 'ssbq/api/ssdb/delsccl',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//v2.3.7 6.变更担保-删除材料
//上传材料 删除 新接口 变更状态
export function delXcxSccl(params) {
    return request({
        url: 'commonapi/api/bgdb/delfile',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

export function commitDb(params) {
    return request({
        url: 'commonapi/api/policy/guarantee/apply',
        method: 'post',
        params: {
            time: new Date().getTime(),
            jbxxid: params
        }
    })
}

/**
 * 删除人员对应的身份证明材料
 * @param {Object} params 请求参数
 * @returns {Promise}
 * */
export function delPersonFile(params) {
    return request({
        url: 'commonapi/api/bgdb/delpersonfile',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        },
        data: params
    })
}

// 变更担保下一步
export function nextStepBgdb(dbid, params) {
    return request({
        url: 'commonapi/api/bgdb/nextstep/' + dbid,
        method: 'post',
        params: {
            time: new Date().getTime(),
            dbid: dbid,
            // 这个ly就是验证修改的法院是否在小程序上开放
            ly: 2
        },
        data: params
    })
}

//v2.3.7 7.变更担保-提交
export function commitBgdb(params) {
    return request({
        url: 'commonapi/api/bgdb/commit',
        method: 'post',
        params: {
            time: new Date().getTime(),
            dbid: params
        },
        // data: {
        //     dbid: params
        // }
    })
}

//v2.3.7 8.变更担保-历史记录
export function getDbbgBgshjl(params) {
    console.log('--4444',params);
    return request({
        url: 'commonapi/api/bgdb/bgshjl',
        method: 'get',
        params: {
            time: new Date().getTime(),
            dbid: params
        }
    })
}

//v2.3.7 8.变更担保-历史记录
export function getBgdbzt(params) {
    return request({
        url: 'commonapi/api/bgdb/xcx/bgdbzt',
        method: 'patch',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

/** v2.3.7 end **/

/** v2.4 start **/
/**
 * 请求下载保单的权限数据
 * @param {Object} params 请求参数
 * @returns {Promise}
 * */
export function getXzbdqx(params) {
    return request({
        url: 'ssbq/api/bxgs/permission_bd',
        method: 'get',
        params:{
            time: new Date().getTime(),
            // 2代表是h5端
            point:'2',
            ...params
        },
    })
}
/** v2.4 end **/
/**
 * 解除保全暂存
 * @param params
 */
export function saveJcbqData(data) {
    return request({
        url: 'ssbq/api/ssbq/jc/tempstore',
        method: 'post',
        params:{
            time: new Date().getTime(),
        },
        data:data
    })
}
/**
 * 解除保全提交
 * @param params
 */
export function submitJcbqData(data) {
    return request({
        url: 'ssbq/api/ssbq/jc/commit',
        method: 'post',
        params:{
            time: new Date().getTime(),
            ...data
        }
    })
}
// 20 申请人列表查询
export function getSqrList(params) {

    return request({
        url: 'ssbq/api/sqrs',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}
/**
 * 解除保全详情查询接口
 * @param params
 */
export function getJcInit(params) {
    // debugger
    return request({
        url: 'ssbq/api/ssbq/jc/init',
        method: 'post',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}

// 获取基本信息
export function getJbxxList(params) {
    return request({
        url: 'ssbq/api/bqsqinfo',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

/**
 * 获取保全解除信息
 * @param params
 */
export function getJcbqxx(params) {
    return request({
        url: 'ssbq/api/ssbq/jc/jbxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 获取保全续行信息
 * @param params
 */
export function getXxbqxx(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/jbxx',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 续行保全详情查询接口
 * @param params
 */
export function getXxInit(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/init',
        method: 'post',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 续行保全暂存
 * @param params
 */
export function saveXxbqData(data) {
    return request({
        url: 'ssbq/api/ssbq/xx/tempstore',
        method: 'post',
        params:{
            time: new Date().getTime(),
        },
        data:data
    })
}
/**
 * 续行保全提交
 * @param params
 */
export function submitXxbqData(data) {
    return request({
        url: 'ssbq/api/ssbq/xx/commit',
        method: 'post',
        params:{
            time: new Date().getTime(),
            ...data
        }
    })
}
// 上传续行保全申请书
export function uploadXXBQFile(data,fn) {
    return request({
        url: 'ssbq/api/ssbq/xx/upload',
        method: 'post',
        headers:{
            "Content-Type": 'multipart/form-data',
        },
        params:{
            time: new Date().getTime(),
        },
        data:data,
        onUploadProgress:fn
    })
}

/**
 * 续行保全上传材料删除
 * @param params
 */
export function delXxbqSccl(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/deletefile',
        method: 'delete',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}

/**
 * 续行保全上传材料列表查询
 * @param params
 */
export function getXxbqScclList(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/sqcl',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 解除保全上传材料列表查询
 * @param params
 */
export function getJcbqScclList(params) {
    return request({
        url: 'ssbq/api/ssbq/jc/sqcl',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 解除保全裁定文书查询接口
 * @param params
 */
export function getJcCdws(params) {
    return request({
        url: 'ssbq/api/ssbq/jc/cdws',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
/**
 * 续行保全裁定文书查询接口
 * @param params
 */
export function getXxCdws(params) {
    return request({
        url: 'ssbq/api/ssbq/xx/cdws',
        method: 'get',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}
